import { createSelector } from '@reduxjs/toolkit';
import { RootState } from 'types';
import { initialState } from './slice';

const selectDomain = (state: RootState) =>
  state.myautoiqTemplateGenerationSettingsComponentState || initialState;

export const selectMyautoiqTemplateGenerationSettings = createSelector(
  [selectDomain],
  state => state.myautoiqTemplateGenerationSettings,
);
